export const tokens = {
    option: {
        padding: 8,
        radius: 12,
    },
    primary: {
        gap: 16,
        detailsGap: 4,
        nameSize: 15,
        disconnectSize: 12,
    },
    thumbnail: {
        size: 40,
        radius: 10,
    },
    supportedCurrency: {
        gap: 4,
        itemSize: 20,
        iconSize: 12,
    },
    balance: {
        maxLength: 8,
    },
};
